import React from "react";

import { useSelection } from "./SelectionContext";
import { findNodeById } from "../NodeUtils";


export function getNodeDisplayName(nodeId, node) {
  if (nodeId?.startsWith("sec-")) return "Section";
  if (nodeId?.startsWith("con-")) return "Container";
  if (nodeId?.startsWith("crd-")) return "Card";
  if (nodeId?.startsWith("el-")) {
    return node?.type === "header" ? "Heading" :
           node?.type === "para" ? "Paragraph" :
           node?.type === "btn" ? "Button" :
           node?.type === "image" ? "Image" :
           "Element";
  }
  return "Unknown";
}
export function Breadcrumb({ page }) {
  const { selectedNodeId, setSelectedNodeId } = useSelection();
  if (!selectedNodeId) return null;

  const result = findNodeById(page, selectedNodeId);
  if (!result) return null;

  const { path } = result;
  if (!path) return null;

  const crumbs = [];

  // Section
  const sec = page.sections[path.sectionIndex];
  if (sec) {
    crumbs.push({
      id: sec.id,
      title: "Section",
    });
  }

  // Container
  const con = sec?.contents?.[path.containerIndex];
  if (con) {
    crumbs.push({
      id: con.id,
      title: "Container",
    });
  }

  // Card
  const card = con?.cards?.[path.cardIndex];
  if (card) {
    crumbs.push({
      id: card.id,
      title: "Card",
    });
  }

  // Element
  const element = card?.elements?.[path.elementIndex];
  if (element) {
    crumbs.push({
      id: element.id,
      title: getNodeDisplayName(element.id, element),
    });
  }

  return (
    <div
      style={{
        display: "flex",justifyContent:"left",
        gap: 3,
        padding: "6px 12px",
        background: "#f6f8fa",
        borderBottom: "1px solid #e1e4e8",
        fontSize: 13,
      }}
    >
      {crumbs.map((crumb, idx) => (
        <span
          key={crumb.id}
          style={{ cursor: "pointer", color: "#1A73E8", display: "flex",justifyContent:"left",gap: 3, }}
          onClick={() => setSelectedNodeId(crumb.id)}
        >
         <div>{crumb.title}</div>  <div>{idx < crumbs.length - 1 && " > "}</div> 
          
        </span>
      ))}
    </div>
  );
}
